import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import update from "immutability-helper";
import { API } from "../../../../Services/api-services";
import { toast } from "react-toastify";
toast.configure();

const sequence = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const AddStudentAssessment = ({
  show,
  closeModalHandler,
  assessmentDetails,
  batchId,
  studentId,
  assessmentCatalog,
  sequence,
}) => {
  const [assessmentObj, setAssessmentObj] = useState({
    assmentSeq: sequence,
    description: "",
    date: "",
    assmntScore: "",
    assmntId: "",
    batchId,
    studentId,
  });
  const [assessmentToggler, setAssessmentToggler] = useState(false); //Used to toggle between dropdown and textfield
  const [loader, setLoader] = useState(false);
  const [prevAssessmnent, setPrevAssessment] = useState(null);

  useEffect(() => {
    if (Object.keys(assessmentDetails).length > 0) {
      const updatedAssessmentObj = update(assessmentObj, {
        assmentSeq: { $set: assessmentDetails.assmntSequence },
        description: { $set: "" },
        date: { $set: assessmentDetails.assmntDate.split("T")[0] },
        assmntScore: { $set: assessmentDetails.assmntScore },
        assmntId: { $set: assessmentDetails.assmntId },
      });
      setAssessmentObj(updatedAssessmentObj);
      setPrevAssessment(assessmentDetails.assmntId);
    }
  }, [assessmentDetails]);

  const toggleAssessmentDescription = () => {
    const updatedAssessment = update(assessmentObj, {
      description: { $set: "" },
      assmntId: { $set: "" },
    });
    setAssessmentObj(updatedAssessment);
    setAssessmentToggler((prev) => !prev);
  };

  const onChangeScoreHandler = (e, type) => {
    switch (type) {
      case "date":
        const updatedDate = update(assessmentObj, {
          date: { $set: e.target.value },
        });
        return setAssessmentObj(updatedDate);
      case "assessmentSeq":
        const updatedSeq = update(assessmentObj, {
          assmentSeq: { $set: e.target.value },
        });
        return setAssessmentObj(updatedSeq);
      case "assessmentScore":
        if (parseInt(e.target.value) > 10)
          return toast.error("Score Cannot be greater than 10", {
            position: toast.POSITION.TOP_RIGHT,
          });
        const updatedScore = update(assessmentObj, {
          assmntScore: { $set: e.target.value },
        });
        return setAssessmentObj(updatedScore);
      case "description":
        const updatedDescription = update(assessmentObj, {
          description: { $set: e.target.value },
        });
        return setAssessmentObj(updatedDescription);
      case "assessmentId":
        const updatedAssessmentId = update(assessmentObj, {
          assmntId: { $set: e.target.value },
        });
        return setAssessmentObj(updatedAssessmentId);
    }
  };

  const submitScore = () => {
    if (assessmentObj.date === "")
      return toast.error("Please Select a Date", {
        position: toast.POSITION.TOP_RIGHT,
      });
    if (assessmentObj.assmentScore === "")
      return toast.error("Please Enter Assessment Score", {
        position: toast.POSITION.TOP_RIGHT,
      });
    if (assessmentToggler === true && assessmentObj.description === "")
      return toast.error("Please Enter a Description", {
        position: toast.POSITION.TOP_RIGHT,
      });
    if (assessmentToggler === false && assessmentObj.assmntId === "")
      return toast.error("Please Select an Assessment", {
        position: toast.POSITION.TOP_RIGHT,
      });
    setLoader(true);
    if (prevAssessmnent === null) {
      API.post("/submitNewAssment", { ...assessmentObj })
        .then((res) => {
          toast.success("Successfully added score", {
            position: toast.POSITION.TOP_RIGHT,
          });
          closeModalHandler(true);
        })
        .catch((e) => {
          setLoader(false);
          console.log("Error while submitting score", e);
          if (e && e.response && e.response.data)
            return toast.error(e.response.data.msg, {
              position: toast.POSITION.TOP_RIGHT,
            });
          else
            return toast.error(
              "Error While Adding Score, Please Try Again Later",
              { position: toast.POSITION.TOP_RIGHT }
            );
        });
    } else {
      API.post("/editAssment", {
        ...assessmentObj,
        previousAssmntId: prevAssessmnent,
      })
        .then((res) => {
          toast.success("Successfully edited score", {
            position: toast.POSITION.TOP_RIGHT,
          });
          closeModalHandler(true);
        })
        .catch((e) => {
          setLoader(false);
          console.error("Error While Updating a Score", e);
          if (e && e.response && e.response.data)
            return toast.error(e.response.data.msg, {
              position: toast.POSITION.TOP_RIGHT,
            });
          else
            return toast.error(
              "Error While Adding Score, Please Try Again Later",
              { position: toast.POSITION.TOP_RIGHT }
            );
        });
    }
  };

  return (
    <>
      <Dialog open={show} fullWidth={true} maxWidth="md">
        <DialogTitle>
          {Object.keys(assessmentDetails).length > 0 ? "Edit" : "Add"} Score
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <label style={{ fontSize: "1rem" }}>Date</label>
              <TextField
                type="date"
                // label="Date"
                value={assessmentObj.date || ""}
                fullWidth
                onChange={(e) => onChangeScoreHandler(e, "date")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                style={{ marginTop: "9px" }}
                label="Assessment Number"
                fullWidth
                onChange={(e) => onChangeScoreHandler(e, "assessmentSeq")}
                value={assessmentObj.assmentSeq}
                disabled
              ></TextField>
            </Grid>
            <Grid item xs={4}>
              <TextField
                style={{ marginTop: "9px" }}
                label="Assessment Score"
                fullWidth
                onChange={(e) => onChangeScoreHandler(e, "assessmentScore")}
                value={assessmentObj.assmntScore}
                type="number"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={8}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <span>Add Your Assessment</span>
                <IconButton onClick={toggleAssessmentDescription}>
                  <AddCircleIcon />
                </IconButton>
              </div>
              {assessmentToggler ? (
                <TextField
                  type="text"
                  label="Assessment Description"
                  fullWidth
                  onChange={(e) => onChangeScoreHandler(e, "description")}
                  value={assessmentObj.description}
                />
              ) : (
                <TextField
                  id="select"
                  label="Assessment Description"
                  value={assessmentObj.assmntId}
                  select
                  fullWidth
                  value={assessmentObj.assmntId}
                  onChange={(e) => onChangeScoreHandler(e, "assessmentId")}
                >
                  {assessmentCatalog.map((assessment) => (
                    <MenuItem value={assessment.assmntId}>
                      {assessment.description}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ backgroundColor: "#ff702d", color: "#ffffff" }}
            onClick={submitScore}
            disabled={loader}
          >
            {Object.keys(assessmentDetails).length > 0 ? "Update" : "Add"} Score
          </Button>
          <Button
            // style={{ backgroundColor: "#f0f0f0", color: "#ff702d" }}
            onClick={() => closeModalHandler(false)}
            disabled={loader}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddStudentAssessment;
